import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const specialDays = lazy(() => import('../../container/userAttendance/specialDays'));
const leave = lazy(() => import('../../container/userAttendance/leave'));
const userAttendance = lazy(() => import('../../container/userAttendance/attendances'));
const earlyLeave = lazy(() => import('../../container/userAttendance/earlyLeave'));
const usersForOthers = lazy(() => import('../../container/userAttendance/usersForOthers'));
const yearlyReservedLeaves = lazy(() => import('../../container/userAttendance/yearlyReservedLeaves'));
const monthlyAttendances  = lazy(() => import('../../container/userAttendance/monthlyAttendances'));
const daySchedules  = lazy(() => import('../../container/userAttendance/daySchedules'));
const attendanceCategories  = lazy(() => import('../../container/userAttendance/attendanceCategories'));
const monthDeclarations  = lazy(() => import('../../container/userAttendance/monthDeclarations'));
const userMonthlyAttendances  = lazy(() => import('../../container/userAttendance/userMonthlyAttendances'));
const rosterAttendances  = lazy(() => import('../../container/userAttendance/rosters'));

const shiftEmployees  = lazy(() => import('../../container/userAttendance/shiftEmployees'));
const sandwiches  = lazy(() => import('../../container/userAttendance/sandwich'));
const refetch  = lazy(() => import('../../container/userAttendance/Refetch/refetchAttendance'));

const UserAttendanceRoutes = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
            <Route path={`${path}/special-days`} component={specialDays}/>
            <Route path={`${path}/leave`} component={leave}/>
            <Route path={`${path}/userAttendance`} component={userAttendance}/>
            <Route path={`${path}/earlyLeave`} component={earlyLeave}/>
            <Route path={`${path}/usersForOthers`} component={usersForOthers}/>
            <Route path={`${path}/yearlyReservedLeaves`} component={yearlyReservedLeaves}/>
            <Route path={`${path}/monthlyAttendances`} component={monthlyAttendances}/>
            <Route path={`${path}/daySchedule`} component={daySchedules}/>
            <Route path={`${path}/attendanceCategories`} component={attendanceCategories}/>
            <Route path={`${path}/userMonthlyAttendances`} component={userMonthlyAttendances}/>
            <Route path={`${path}/rosterAttendances`} component={rosterAttendances}/>
            <Route path={`${path}/monthDeclarations`} component={monthDeclarations}/>

            <Route path={`${path}/shiftEmployees`} component={shiftEmployees}/>
            <Route path={`${path}/sandwiches`} component={sandwiches}/>
            <Route path={`${path}/refetch`} component={refetch}/>
        </Switch>
    );
};

export default UserAttendanceRoutes;
